import apiClient from "../axiosInterceptor";

export const notificationService = {
  getNotifications: (userId, type) => {
    return apiClient.get(`/notification/client/${userId}&${type}`);
  },
  markNotificationRead: (notificationId, isRead) => {
    return apiClient.put(`/notification/isRead/${notificationId}&${isRead}`);
  },
  deleteNotification: (notificationId) => {
    return apiClient.delete(`/notification/${notificationId}`);
  },
  getUserGroups: (clientId) => {
    return apiClient.get(`/notification/fetch/userGroups/client/${clientId}`);
  },
  getUsersList: (clientId) => {
    return apiClient.get(`/notification/client/${clientId}/fetch/allUsers`);
  },
  createNotification: (notifType, data) => {
    return apiClient.post(`/notification/type/${notifType}/create`, data);
  },
  getNotificationTemplates: (userId) => {
    return apiClient.get(`/autoNotification/templates/client/${userId}`);
  },
  getNotificationTemplateDetails: (templateId) => {
    return apiClient.get(`/autoNotification/template/${templateId}`);
  },
  deleteNotificationTemplate: (templateId) => {
    return apiClient.delete(`/autoNotification/template/${templateId}`);
  },
  updateNotificationTemplateStatus: (templateId, status) => {
    return apiClient.put(`/autoNotification/template/${templateId}/status/${status}`);
  },
  getAutoNotificationDropdown: (clientId) => {
    return apiClient.get(`/autoNotification/dropdown/client/${clientId}`);
  },
  createTemplate: (data) => {
    return apiClient.post(`/autoNotification/template`, data);
  },
  updateTemplate: (templateId, data) => {
    return apiClient.put(`/autoNotification/template/${templateId}`, data);
  },
};
